<section class="@container h-full">
  <div class="flex h-full min-w-0 flex-col gap-4">
    <div class="flex min-w-0 flex-1 flex-col gap-4 @xl:flex-row">
      <!-- STATS -->
      <div class="flex flex-col gap-4 @xl:h-full @xl:w-72 @xl:shrink-0">
        <div class="flex shrink-0 items-center rounded-lg border border-gray-200 bg-gray-50 p-4">
          <mat-slide-toggle
            class="[&_.mdc-label]:!ml-2 [&_.mdc-label]:!text-sm [&_.mdc-label]:!font-semibold [&_.mdc-label]:!text-gray-600"
            color="accent"
            [class.status-toggle--active]="status() === STATUS.ACTIVE"
            [class.status-toggle--inactive]="status() !== STATUS.ACTIVE"
            [checked]="status() === STATUS.ACTIVE"
            (change)="status.set($event.checked ? STATUS.ACTIVE : STATUS.DISABLED)"
          >
            {{ (status() === STATUS.ACTIVE ? 'IOT_DICTIONARY.ACTIVE_CAPITALIZE' : 'IOT_DICTIONARY.INACTIVE_CAPITALIZE') | translate }}
          </mat-slide-toggle>
        </div>

        <div class="flex flex-1 flex-col gap-6 rounded-lg border border-gray-200 bg-gray-50 p-4">
          <div class="flex items-center gap-3">
            <span class="flex size-9 shrink-0 items-center justify-center rounded-md border border-gray-300 bg-gray-200 text-gray-500">
              <mat-icon class="!h-4 !w-4 !text-base !leading-4">history</mat-icon>
            </span>
            <div class="flex min-w-0 flex-col">
              <span class="text-[10px] font-semibold tracking-wide text-gray-400 uppercase">{{ 'IOT_DICTIONARY.LAST_RUN' | translate }}</span>
              <span class="text-xs font-semibold text-gray-600">{{ ($safeNavigationMigration(favoriteView()?.export?.lastRun) | dateFormat) ?? '-' }}</span>
            </div>
          </div>

          <div class="flex items-center gap-3">
            <span
              class="flex size-9 shrink-0 items-center justify-center rounded-md border"
              [class]="status() === STATUS.ACTIVE ? 'border-[#b9d0ee] bg-[#dbe6f5] text-[#4f78b7]' : 'border-gray-300 bg-gray-200 text-gray-500'"
            >
              <mat-icon class="!h-4 !w-4 !text-base !leading-4">schedule</mat-icon>
            </span>
            <div class="flex min-w-0 flex-col">
              <span class="text-[10px] font-semibold tracking-wide text-gray-400 uppercase">{{ 'IOT_DICTIONARY.NEXT_RUN' | translate }}</span>
              <span class="text-xs font-semibold text-gray-600">{{ (nextRun() | dateFormat) ?? '-' }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- CRON SCHEDULER -->
      <div class="flex min-h-0 w-full min-w-0 flex-1 flex-col gap-2.5 overflow-hidden rounded-lg border border-gray-200 bg-gray-50 p-4">
        <iot-platform-ui-cron-configurator
          class="flex min-h-0 w-full flex-1"
          [cron]="$safeNavigationMigration(favoriteView()?.export?.cron)"
          (cronChange)="cron.set($event)"
        />
      </div>
    </div>

    <!-- PREVIEW -->
    <div class="flex w-full shrink-0 flex-row items-center justify-between gap-2 rounded-lg border border-gray-200 bg-gray-50 p-4">
      <span class="text-[11px] font-semibold tracking-wide text-gray-400 uppercase">{{ 'CRON_CONFIGURATOR.PREVIEW.LABEL' | translate }}</span>
      <div class="flex items-center gap-2">
        <span class="text-xs font-semibold text-gray-600">
          {{ preview().key | translate: { time: preview().time, timezone: preview().timezone, day: preview().day | translate } }}
        </span>
        <mat-icon
          class="!h-4 !w-4 !text-base !leading-4 text-gray-400"
          matTooltipClass="regular-tooltip"
          matTooltipPosition="above"
          [matTooltip]="'CRON_CONFIGURATOR.PREVIEW.TIMEZONE_HINT' | translate"
          >info_outline</mat-icon
        >
      </div>
    </div>
  </div>
</section>
